module.exports = __webpack_public_path__ + "img/img2.13f361c2.svg";